export const tripStatus = {
    inTime: "In Time",
    delayed: "Delayed",
    inTransit: "In Transit",
    noGPS: "No GPS",
    noSignal: "No Signal"
}